import { ContentTypes, requestToCMS } from './requestToCMS';
import { Endpoint, getStrapiEndpoint } from '../../constants';

/**
 * Configuration for the put request made to the CMS.
 */
type PutConfig = {
    /*
     The endpoint to make the request to
     */
    endpoint: Endpoint;
    /*
    The id of the entity that should be updated.
     */
    id: string;
    /*
     The data that should be updated on the backend. It can either be a json string or
     a FormData object.
     */
    body: FormData | string;
    /*
    Content type of the body. If not defined application/json is used as default
     */
    contentType?: ContentTypes;
    /*
    The token to use in the request. Either the user token for logged in/user specific actions or our API token for general requests.
     */
    jwt: string;
};

const putToCMS = async <T, E = any>(config: PutConfig) => {
    const requestUrl = `${getStrapiEndpoint(config.endpoint)}/${config.id}`;
    return requestToCMS<T, E>({
        url: requestUrl,
        method: 'PUT',
        body: config.body,
        contentType: config.contentType,
        accessToken: config.jwt
    });
};

export { putToCMS };
